const comments = [
  {
    name: '漫画迷小鹿',
    text: '终于找到专门推荐韩国漫画的地方了！排行榜更新很及时，我追的几部高分必看作品每次都能第一时间发现，推荐的质量也靠谱。',
    tag: '忠实读者',
  },
  {
    name: '深夜追漫人',
    text: '免费韩国漫画大全这个入口太实用了，不用到处翻找。人气榜单帮我筛掉了很多踩雷作品，现在追的几部全是这里挖到的宝藏。',
    tag: '活跃用户',
  },
  {
    name: '柠檬不酸',
    text: '作为一个刚入坑韩国漫画的新手，这里的分类和推荐特别友好。好看的韩国漫画推荐栏目让我一周内追完了三部神作，根本停不下来！',
    tag: '新晋漫友',
  },
  {
    name: '画风控阿远',
    text: '我最看画风，这里精选的韩国漫画高分推荐真的很对我的胃口。不管是唯美浪漫还是硬核动作，推荐列表里总有惊喜。',
    tag: '资深读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">读者热评</h2>
          <p className="mt-3 text-sm text-foreground-600">看看漫友们的真实声音</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-heading text-primary-600">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">{c.name}</div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">{c.tag}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{c.text}</p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}